import { SimpleListItem } from '@components'
import { Button } from '@heroui/react'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'

const DeliverySummaryItem = ({ 
  buttonColor,
  caption, 
  count,
  handleGetDetailedStats, 
  icon: Icon, 
  iconColor, 
  isLoading
}) => (
  <SimpleListItem>
    <div className='flex justify-between w-full gap-2'>
      <div className='flex items-center gap-2'>
        <Icon className={`w-7 h-7 mr-2 ${iconColor}`} />
        <span className='font-semibold'>{count}</span> {caption}
      </div>

      {count > 0 && (
        <Button className="text-white" color={buttonColor} size="sm" onPress={() => handleGetDetailedStats()} isLoading={isLoading}>
          View
          <ChevronRightIcon className='w-4 h-4 ml-1' />
        </Button>
      )}
    </div>
  </SimpleListItem>
)

DeliverySummaryItem.propTypes = {
  buttonColor: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  handleGetDetailedStats: PropTypes.func.isRequired,
  icon: PropTypes.elementType.isRequired,
  iconColor: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default DeliverySummaryItem